import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2 13V7a3 3 0 0 0 3-3h12a3 3 0 0 0 3 3v2.101c.742.103 1.421.28 2 .514V4.75C22 3.11 20.527 2 19 2H3C1.473 2 0 3.11 0 4.75v10.5C0 16.89 1.473 18 3 18h9v-2H5a3 3 0 0 0-3-3m1-9c-.682 0-1 .457-1 .75V5a1 1 0 0 0 1-1m17 1v-.25c0-.293-.318-.75-1-.75a1 1 0 0 0 1 1M2 15.25V15a1 1 0 0 1 1 1c-.682 0-1-.457-1-.75",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 6a4 4 0 0 1 3.969 3.5c-.784.226-1.48.52-2.001.861q.031-.176.032-.361a2 2 0 1 0-1 1.732v2.142A4 4 0 1 1 11 6"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18.5 10c3.038 0 5.5 1.343 5.5 3v7.5c0 1.218-.877 2.111-1.832 2.642-.99.55-2.288.858-3.668.858s-2.678-.309-3.668-.858C13.877 22.612 13 21.718 13 20.5V13c0-1.657 2.462-3 5.5-3m2.931 2.634c.284.155.433.283.51.366-.077.083-.226.21-.51.366-.648.353-1.68.634-2.931.634-1.25 0-2.283-.28-2.931-.634-.285-.155-.433-.283-.51-.366.077-.083.226-.21.51-.366.648-.353 1.68-.634 2.931-.634 1.25 0 2.283.28 2.931.634m-6.445.261v.003l.003.005zM22 15.316V16.5c0 .162-.13.52-.804.894-.64.355-1.59.606-2.696.606-1.105 0-2.057-.251-2.696-.606-.674-.374-.804-.732-.804-.894v-1.186c.95.429 2.17.686 3.5.686s2.55-.257 3.5-.686m0 5.185v-1.269c-.966.494-2.197.769-3.5.769s-2.534-.275-3.5-.769V20.5c0 .162.13.52.804.894.64.355 1.59.606 2.696.606 1.105 0 2.057-.251 2.696-.606.674-.374.804-.732.804-.894",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }